import { SessionHelper } from "app/helpers/sessionHelper";
import { Redirect, Route } from "react-router-dom";

// Use HOC to define a shared layout for the desktop screens
// renders either requested screen component or redirects to "/"
const PrivateRoute = (
  { component: Component, ...rest }: any // desktop PrivateRoute
) => (
  <Route
    {...rest}
    render={props => {
      // horrible solution when user goes from mobile to desktop using asian view
      if (
        SessionHelper.isAuthenticated() &&
        SessionHelper.isAsianSessionView() &&
        !props.match.url.includes("asian")
      ) {
        console.log("redirect");
        window.location.pathname = "/asian/events/";
      }
      if (
        SessionHelper.isAuthenticated() &&
        !SessionHelper.isAsianSessionView() &&
        props.match.url.includes("asian")
      ) {
        console.log("euro redirect");
        window.location.pathname = "/events/";
      }

      return SessionHelper.isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to="/" />
      );
    }}
  />
);

export default PrivateRoute;
